import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide"; 
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import { addNewAircraft, 
  // getAircraftAeroApi, 
  // getFlightData 
} 
  from "../Axios/Axios";
import ClearIcon from "@mui/icons-material/Clear";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import { BsPlusLg } from "react-icons/bs";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import { toast, ToastContainer, useToast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AddAircraftModal.scss";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PreviewModal from "./PreviewModal";
import AddFlightModal from "./AddFlightModal";
import useCustomToast from "../../hooks/useCustomToast";
import { Toaster } from "react-hot-toast";
const CrewOptions = [
  { value: "PIC", label: "PIC" },
  { value: "SIC", label: "SIC" },
  { value: "IP", label: "IP" },
  { value: "EP", label: "EP" },
  { value: "LCA", label: "LCA" },
  { value: "Solo", label: "Solo" },
  { value: "Dual Received", label: "Dual Received" },
  { value: "Student Pilot", label: "Student Pilot" },
];

const OperationOptions = [
  { value: "Part 141", label: "Part 141" },
  { value: "Part 61", label: "Part 61" },
  { value: "Part 91", label: "Part 91" },
  { value: "Part 121", label: "Part 121" },
  { value: "Part 135", label: "Part 135" },
  { value: "Military", label: "Military" },
];

const BodyTypeOptions =[
{value: "Wide Body", label: "Wide Body"},
{ value: "Narrow Body", label: "Narrow Body" },
{ value:"Commuter", label: "Commuter"},
{ value:"Regional", label: "Regional"},
]

const EngineTypeOptions =[
  {value: "piston_single_engine", label: "Piston Single Engine"},
  { value: "piston_multi_engine", label: "Piston Multi Engine" },
  { value:"turboprop_engine", label: "Turboprop Engine"},
  { value:"turbojet_engine", label: "Turbojet Engine"},
  { value:"turbofan_engine", label: "Turbofan Engine"},
  { value:"turboshaft_engine", label: "Turboshaft Engine"},
  ]

const style = {
  position: "fixed",
  top: "0",
  right: "0",
  width: "60%",
  maxWidth: "500px",
  maxHeight: "100%",
  bgcolor: "white",
  boxShadow: 24,
  paddingLeft: "3%",
  overflow: "auto",
  zIndex: 9999,

  "&::-webkit-scrollbar": {
    //Beautifying scrollbar
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
};

interface AddAircraftModalProps {
  open: boolean;
  onClose: () => void;
  
  // landingsprop: number; // Add the landings prop here
}

function AddAircraftModal({ open, onClose }: AddAircraftModalProps) {
  const customToast = useCustomToast();
  const [registrationNo, setRegistrationNo] = React.useState("");
  const [addAircraft,setAddAircraft] = React.useState(false);
  const [formSubmit,setFormSubmit] = React.useState(false);
  const [aircarftid, setAircarftid] = React.useState("");
  const [aircraftEngineCount, setAircraftEngineCount] = React.useState("");
  const [aircrafttype, setAircrafttype] = React.useState("");
  const [bodytype, setBodytype] = React.useState("");
  const [enginetype, setEnginetype] = React.useState("");
  const [defaultValue, setDefaultValue] = React.useState(false);
  const [favorite, setFavorite] = React.useState(false);
  const [complex, setComplex] = React.useState(false);
  const [pressurized, setPressurized] = React.useState(false);
  const [retractable, setRetractable] = React.useState(false);
  const [highPerformance, setHighPerformance] = React.useState(false);
  const [amphibian, setAmphibian] = React.useState(false);
  const [skis, setSkis] = React.useState(false);
  const [EFIS, setEFIS] = React.useState(false);
  const [fuelInjection, setFuelInjection] = React.useState(false);
  const [tailWheel, setTailWheel] = React.useState(false);
  const [aerobatic, setAerobatic] = React.useState(false);
  const [experimental, setExperimental] = React.useState(false);
  const [warBird, setWarBird] = React.useState(false);
  const [fighterHeavy, setFighterHeavy] = React.useState(false);
  const [aircraftImage, setImage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [autoLog, setAutoLog] = React.useState<boolean>(false);
  const [typeOfOperation, setTypeOfOperation] = React.useState("");
  const [selectedCrewOptions, setSelectedCrewOptions] = useState<any>([]);
  const [selectedOperationOptions, setSelectedOperationOptions] = useState<any>(
    []
  );
  const [selectedBodyTypeOptions, setSelectedBodyTypeOptions] = useState<any>(
    []
  );
  const [selectedEngineTypeOptions, setSelectedEngineTypeOptions] = useState<any>(
    []
  );
  const [landings, setLandings] = useState(0);
  const [isRegID, setIsRegID] = React.useState<boolean>(false);

  const [isCustomFieldEditable, setIsCustomFieldEditable] = useState(false);

  const [selectedFileName, setSelectedFileName] = useState("");
  const [instrumentTimePercentage, setInstrumentTimePercentage] = useState("");
  const [approaches, setApproaches] = useState("");
  const [autoLogFrequency, setAutoLogFrequency] = useState("");
  const [customFields, setCustomFields] = useState<
    { id: number; value: string }[]
  >([]);

  const [customValue, setCustomValue] = useState("");

  const resetFormState = () => {
    setRegistrationNo("");
    setAddAircraft(false);
    setFormSubmit(false);
    setAircarftid("");
    setAircraftEngineCount("");
    setAircrafttype("");
    setBodytype("");
    setEnginetype("");
    setDefaultValue(false);
    setFavorite(false);
    setComplex(false);
    setPressurized(false);
    setRetractable(false);
    setHighPerformance(false);
    setAmphibian(false);
    setSkis(false);
    setEFIS(false);
    setFuelInjection(false);
    setTailWheel(false);
    setAerobatic(false);
    setExperimental(false);
    setWarBird(false);
    setFighterHeavy(false)
    setImage("");
    setLoading(false);
    setError("");
    setAutoLog(false);
    setTypeOfOperation("");
    setSelectedCrewOptions([]);
    setSelectedOperationOptions([]);
    setLandings(0);
    setIsRegID(false);
    setCustomFields([]);
    setIsCustomFieldEditable(false);
    setSelectedFileName("");
    setInstrumentTimePercentage("");
    setApproaches("");
    setAutoLogFrequency("");
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target && event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];

      if (selectedFile) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target?.result as string;
          setImage(fileData);
          setSelectedFileName(selectedFile.name); // Update the selected file name
        };

        reader.readAsDataURL(selectedFile); // Read the selected file as a data URL
      }
    }
  };

  const handleITPChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInstrumentTimePercentage(e.target.value);
  };

  const handleApproachesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setApproaches(e.target.value);
  };

  const toggleCustomField = () => {
    setIsCustomFieldEditable(!isCustomFieldEditable);
  };

  const addCustomField = () => {
    setCustomFields([
      ...customFields,
      { id: Date.now(), value: "Custom Field" },
    ]);
  };

  const removeCustomField = (idToRemove: number) => {
    setCustomFields(customFields.filter((field) => field.id !== idToRemove));
  };

  const handleSelectBodyTypeChange=(selected: any) => {
    setBodytype(selected.value); // Assuming 'selected' has a 'value' property
    setSelectedBodyTypeOptions(selected);
  };

  const handleSelectEngineTypeChange=(selected: any) => {
    setEnginetype(selected.value); // Assuming 'selected' has a 'value' property
    setSelectedEngineTypeOptions(selected);
  };


  const handleSelectOperationChange = (selected: any) => {
    setTypeOfOperation(selected.value); // Assuming 'selected' has a 'value' property
    setSelectedOperationOptions(selected);
  };

  const handleMultiSelectCrewChange = (selected: any) => {
    console.log(selected);
    setSelectedCrewOptions(selected); // Assuming 'selected' has
  };

  //Managing All Checkboxes
  const handleDefaut = (event: any) => {
    console.log(!defaultValue);
    setDefaultValue(!defaultValue);
  };
  const handleFavorite = (event: any) => {
    setFavorite(!favorite);
    console.log(favorite);
  };

  const handleAerobatic = (event: any) => {
    setAerobatic(!aerobatic);
    console.log(aerobatic);
  };

  const handleComplex = (event: any) => {
    setComplex(!complex);
    console.log(complex);
  };
  const handlePressurized = (event: any) => {
    setPressurized(!pressurized);
    console.log(pressurized);
  };

  const handleRetractable = (event: any) => {
    setRetractable(!retractable);
    console.log(retractable);
  };

  const handleHighPerformance = (event: any) => {
    setHighPerformance(!highPerformance);
    console.log(highPerformance);
  };

  const handleAmphibian = (event: any) => {
    setAmphibian(!amphibian);
    console.log(amphibian);
  };

  const handleSkis = (event: any) => {
    setSkis(!skis);
    console.log(skis);
  };

  const handleEFIS = (event: any) => {
    setEFIS(!EFIS);
    console.log(EFIS);
  };
  const handleFuelInjection = (event: any) => {
    setFuelInjection(!fuelInjection);
    console.log(fuelInjection);
  };
  const handleTailWheel = (event: any) => {
    setTailWheel(!tailWheel);
    console.log(tailWheel);
  };
  const handleWarBird = (event: any) => {
    setWarBird(!warBird);
    console.log(warBird);
  };
  const handleExperimental = (event: any) => {
    setExperimental(!experimental);
    console.log(experimental);
  };

  const handleFighterHeavy = (event: any) => {
    setFighterHeavy(!fighterHeavy);
    console.log(experimental);
  };

  const handleAutoLog = () => {
    setAutoLog((prevAutoLog) => !prevAutoLog);
    console.log(autoLog);
  };
  const handleLandings = () => {
    setLandings(landings === 1 ? 0 : 1);
    console.log(landings);
  };

  const handleOptionChange = (event: any) => {
    setAutoLogFrequency(event.target.value);
  };

  // For Registration Number
  const handleReg = async (e: React.ChangeEvent<HTMLInputElement>) => {
   
        setRegistrationNo(e.target.value);
 
  };

  //Add Aircraft
  const onSubmitForm = async (e: any) => {
    e.preventDefault();
    // if (isRegID) {
      try {
        const data2 = {
          registrationNo: registrationNo,
          aircraftImage: aircraftImage,
          ident: aircarftid,
          model: aircrafttype,
          defaultValue: defaultValue,
          favorite: favorite,
          defaultCrewPosition: selectedCrewOptions,
          typeOfOperation: typeOfOperation,
          bodyType: bodytype,
          engineType: enginetype,
          complex: complex,
          pressurized: pressurized,
          retractable: retractable,
          highPerformance: highPerformance,
          amphibian: amphibian,
          skis: skis,
          EFIS: EFIS,
          fuelInjection: fuelInjection,
          tailWheel: tailWheel,
          aerobatic: aerobatic,
          experimental: experimental,
          warbird: warBird,
          fighterHeavy:fighterHeavy,
          autoLog: autoLog,
          landing: landings,
          approaches: approaches,
          instrumentTimePercentage: instrumentTimePercentage,
          autoLogFrequency: autoLogFrequency,
          numberOffrequency: 0,
          // identIcao: identIcao,
          // identIata: identIata,
          customFields: customFields.map((field, index) => ({
            name: field.value, // Use field.value as the name
            value: customValue, // Use field.customFieldValue as the value (string)
          })),

          // confirm:confirm,
          // customFields:customFields,
        };
        console.log(data2, "body1 Payload");
        const res = await addNewAircraft(data2);
        console.log(res.data, "post");
        setFormSubmit(true);
        customToast("Aircraft Added successfully", "success");
        // window.location.reload();
        handleCloseAircraft();
        resetFormState();
      } catch (error: any) {
        console.error(error);
        customToast("Failed to add Aircraft", "error");
      }
    // } else {
    //   showFailedToastMessage();
    //   setFormSubmit(false);
    // }
  };
  const handleAddAircraft = () => {
    setAddAircraft(true);
  };

  const handleAddFlight = () => {
    setAddAircraft(false);
  };

  const handleCloseAircraft = () => {
    // Call the onClose prop to close the modal
    onClose();
  };
  return (
    <div>
      <Toaster/>
      <Modal open={open} onClose={onClose}>
      <Slide direction="left" in={open} mountOnEnter unmountOnExit>

        <Box sx={{ ...style, display: "flex", justifyContent: "center" }}>
          <form onSubmit={onSubmitForm}>
            <div className="clear_icon">
              <ClearIcon
                style={{ marginTop: "2%" }}
                onClick={handleCloseAircraft}
              />
            </div>
            <div>
              <h2 className="heading2">Add New Aircraft</h2>
              <p className="heading4 secondary" style={{ fontWeight: "600" }}>
                Aircraft Details
              </p>
              <div
                className="f-flex"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <label className="heading5" style={{ marginBottom: "5px" }}>
                  Registeration number
                </label>
              </div>
              {error && (
                <div
                  style={{ color: "red", marginTop: "4px" }}
                  className="heading6"
                >
                  {error}
                </div>
              )}{" "}
              {/* Error display */}
              <div
                className="f-flex"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div className="add_group">
                  <input
                    type="text"
                    placeholder="UTF3235"
                    className="add_input"
                    id="registeration_no"
                    onChange={(e) => handleReg(e)}
                  />
                  {loading && <CircularProgress size={20} />}{" "}
                  {/* Loading spinner */}
                </div>

                {/* Image Upload */}
                <div
                  style={{
                    border: "none !important",
                    padding: 0,
                    paddingLeft: "3px",
                    paddingRight: "3px",
                    width: "36%",
                    marginRight: "10%",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "1rem",
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    id="aircraftImage"
                    name="aircraftImage"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />

                  {selectedFileName ? (
                    <>
                      <label
                        htmlFor="aircraftImage"
                        style={{
                          cursor: "pointer",
                          padding: 0,
                          margin: 0,
                          color: "#00AF80",
                          marginRight: "4px",
                        }}
                      >
                        <CloudUploadIcon style={{ fontSize: "40px" }} />
                      </label>

                      <span style={{ fontSize: "10px" }}>
                        {selectedFileName}
                      </span>
                    </>
                  ) : (
                    <label
                      htmlFor="aircraftImage"
                      style={{
                        cursor: "pointer",
                        padding: 0,
                        margin: 0,
                        color: "#00AF80",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CloudUploadIcon style={{ fontSize: "40px" }} />
                      <span className="heading4" style={{ marginLeft: "4px" }}>
                        Upload Image
                      </span>
                    </label>
                  )}
                </div>

                {/* Image Upload end*/}
              </div>
              <div
                className="f-flex"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <label className="heading5" style={{ marginBottom: "5px" }}>
                  Aircraft ID
                </label>
                <label
                  className="heading5"
                  style={{ marginBottom: "5px", marginRight: "30%" }}
                >
                  Aircraft Type
                </label>
              </div>
              <div
                className="f-flex"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div className="add_group">
                  <input
                    type="text"
                    value={aircarftid}
                    placeholder="ID"
                    className="add_input"
                    onChange={(e) => setAircarftid(e.target.value)}
                  />
                </div>
                <div className="add_group" style={{ marginRight: "10%" }}>
                  <input
                    value={aircrafttype}
                    type="text"
                    placeholder="Type"
                    className="add_input"
                    onChange={(e) => setAircrafttype(e.target.value)}
                  />
                </div>
              </div>
              <div
                className="f-flex"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div className="add_span">
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="defaultValue"
                    name="defualt"
                    onChange={handleDefaut}
                    checked={defaultValue}
                  />
                  <label className="heading4">Default</label>
                </div>
                <div className="add_span" style={{ marginRight: "30%" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="favorite"
                    name="favorite"
                    onChange={handleFavorite}
                    checked={favorite}
                  />
                  <label className="heading4">Favorite</label>
                </div>
              </div>
              <div
                className="f-flex"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: "22%",
                }}
              >
                <label className="heading5" style={{ marginBottom: "5px" }}>
                  Default Crew Position
                </label>
                <label className="heading5" style={{ marginBottom: "5px" }}>
                  Type of Operations
                </label>
              </div>
              <div className="f-flex">
                <div style={{ flex: "50%", padding: 0, margin: 0 }}>
                  <Select
                    isMulti
                    options={CrewOptions}
                    value={selectedCrewOptions}
                    onChange={handleMultiSelectCrewChange}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        marginBottom: "5%",
                        maxWidth: "80%",
                        fontSize:"14px"
                      }),
                      clearIndicator: () => ({ display: "none" }), // Hide the clear indicator (X icon)
                    }}
                  />
                </div>

                <div style={{ flex: "50%" }}>
                  <Select
                    id="typeOfOperation"
                    name="typeOfOperation"
                    options={OperationOptions}
                    value={selectedOperationOptions}
                    onChange={handleSelectOperationChange}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        marginBottom: "5%",
                        maxWidth: "80%",
                        fontSize:"14px"
                      }),
                    }}
                  />
                </div>
              </div>
              <div
                className="f-flex"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <label className="heading5" style={{ marginBottom: "5px",marginTop:"2%" }}>
                  Aircraft Body Type
                </label>
                <label
                  className="heading5"
                  style={{ marginBottom: "5px", marginRight: "30%",marginTop:"2%" }}
                >
                  Engine Type
                </label>
              </div>
              <div
                className="f-flex"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                   <div style={{ flex: "50%" }}>
                  <Select
                    id="BodyType"
                    name="BodyType"
                    options={BodyTypeOptions}
                    value={selectedBodyTypeOptions}
                    onChange={handleSelectBodyTypeChange}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        marginBottom: "8%",
                        maxWidth: "80%",
                        fontSize:"14px"
                      }),
                    }}
                  />
                </div>
                <div style={{ flex: "50%" }}>
                  <Select
                    id="EngineType"
                    name="EngineType"
                    options={EngineTypeOptions}
                    value={selectedEngineTypeOptions}
                    onChange={handleSelectEngineTypeChange}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        marginBottom: "8%",
                        maxWidth: "80%",
                        fontSize:"14px"
                      }),
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="add_span" style={{ flexGrow: "1" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="complex"
                    name="complex"
                    onChange={handleComplex}
                    checked={complex}
                  />
                  <label className="heading4">Complex</label>
                </div>
                <div
                  className="add_span"
                  style={{ flexGrow: "1", marginLeft: "6%" }}
                >
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="pressurized"
                    name="pressurized"
                    onChange={handlePressurized}
                    checked={pressurized}
                  />
                  <label className="heading4">Pressurized</label>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="add_span" style={{ flexGrow: "1" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="retractable"
                    name="retractable"
                    onChange={handleRetractable}
                    checked={retractable}
                  />
                  <label className="heading4">Retractable</label>
                </div>
                <div
                  className="add_span"
                  style={{ flexGrow: "1", marginLeft: "12%" }}
                >
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="highPerformance"
                    name="highPerformance"
                    onChange={handleHighPerformance}
                    checked={highPerformance}
                  />
                  <label className="heading4">High Performance</label>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="add_span" style={{ flexGrow: "1" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="amphibian"
                    name="amphibian"
                    onChange={handleAmphibian}
                    checked={amphibian}
                  />
                  <label className="heading4">Amphibian</label>
                </div>
                <div
                  className="add_span"
                  style={{ flexGrow: "1", marginRight: "12%" }}
                >
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="skis"
                    name="skis"
                    onChange={handleSkis}
                    checked={skis}
                  />
                  <label className="heading4">Skis</label>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="add_span" style={{ flexGrow: "2" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="EFIS"
                    name="EFIS"
                    onChange={handleEFIS}
                    checked={EFIS}
                  />
                  <label className="heading4">EFIS</label>
                </div>
                <div
                  className="add_span"
                  style={{ flexGrow: "2", marginLeft: "16%" }}
                >
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="fuelInjection"
                    name="fuelInjection"
                    onChange={handleFuelInjection}
                    checked={fuelInjection}
                  />
                  <label className="heading4">Fuel Injection</label>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="add_span" style={{ flexGrow: "2" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="tailWheel"
                    name="tailWheel"
                    onChange={handleTailWheel}
                    checked={tailWheel}
                  />
                  <label className="heading4">Tailwheel</label>
                </div>
                <div
                  className="add_span"
                  style={{ flexGrow: "2", marginLeft: "1%" }}
                >
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="aerobatic"
                    onChange={handleAerobatic}
                    checked={aerobatic}
                  />
                  <label className="heading4">Aerobatic</label>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="add_span" style={{ flexGrow: "2" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="experimental"
                    onChange={handleExperimental}
                    checked={experimental}
                  />

                  <label className="heading4">Experimental</label>
                </div>
                <div
                  className="add_span"
                  style={{ flexGrow: "2", marginRight: "8%" }}
                >
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="warBird"
                    name="warbird"
                    onChange={handleWarBird}
                    checked={warBird}
                  />
                  <label className="heading4">Warbird</label>
                </div>
              </div>
              <div
                  className="add_span"
                  style={{ flexGrow: "2", marginRight: "8%" }}
                >
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="warBird"
                    name="warbird"
                    onChange={handleFighterHeavy}
                    checked={fighterHeavy}
                  />
                  <label className="heading4">Fighter Heavy</label>
                </div>
              {/* Auto Log */}
              <div className="add_span" style={{ flexGrow: "2" }}>
                <label
                  className="heading4 secondary"
                  style={{ fontWeight: "600" }}
                >
                  Autolog
                </label>
              </div>
              <div>
                <div className="add_span" style={{ flexGrow: "2" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="autoLog"
                    name="autoLog"
                    onChange={handleAutoLog}
                    checked={autoLog}
                  />
                  <label className="heading4">Auto Log</label>
                </div>

                {autoLog && (
                  <div
                    style={{
                      background: "#F8FAFB",
                      padding: "6px 5px 3px 5px",
                      width:"90%"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "5px",
                      }}
                    >
                      <div className="add_span">
                        <input
                          type="checkbox"
                          className="add_checkbox"
                          id="landings"
                          name="landings"
                          onChange={handleLandings}
                          checked={landings === 1}
                        />
                        <label className="heading4">Landings</label>
                        
                      </div>
                      {/* <div
                      className="heading4"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                        padding: "0px 20px 0px 20px",
                      }}
                    >
                      <label>
                        <input
                          type="radio"
                          name="flightOption"
                          value="everyOtherFlight"
                          checked={autoLogFrequency === "everyOtherFlight"}
                          onChange={handleOptionChange}
                        />
                        Every other Flight
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="flightOption"
                          value="always"
                          checked={autoLogFrequency === "always"}
                          onChange={handleOptionChange}
                        />
                        Always
                      </label>
                    </div> */}
                    </div>
                    <div
                      className="add_span"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <div>
                        <label
                          className="heading4"
                          htmlFor="instrumentTimePercentage"
                        >
                          <span style={{ marginLeft: "25px" }}>
                            {" "}
                            Instrument Time %:
                          </span>
                        </label>

                        <input
                          className="add_input"
                          type="text"
                          id="instrumentTimePercentage"
                          name="instrumentTimePercentage"
                          style={{ width: "60%", height: "100%" }}
                          placeholder="Enter"
                          onChange={handleITPChange}
                        />
                      </div>
                      <div>
                        <label className="heading4" htmlFor="approaches">
                          <span style={{ marginLeft: "5%" }}>Approaches:</span>
                        </label>
                        <input
                          className="add_input"
                          type="text"
                          id="approaches"
                          name="approaches"
                          style={{ width: "70%", height: "100%" }}
                          placeholder="Enter"
                          onChange={handleApproachesChange}
                        />
                      </div>
                    </div>

                    <div
                      className="heading4"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                        padding: "0px 20px 0px 20px",
                      }}
                    >
                      <label>
                        <input
                          type="radio"
                          name="flightOption"
                          value="everyOtherFlight"
                          checked={autoLogFrequency === "everyOtherFlight"}
                          onChange={handleOptionChange}
                        />
                        Every other Flight
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="flightOption"
                          value="always"
                          checked={autoLogFrequency === "always"}
                          onChange={handleOptionChange}
                        />
                        Always
                      </label>
                    </div>
                  </div>
                )}
              </div>
              {/* Auto Log  End*/}
              {/* Custom Field */}
              <div className="add_span" style={{ flexGrow: "2" }}>
                <label
                  className="heading4 secondary"
                  style={{ fontWeight: "600" }}
                >
                  Custom Fields
                </label>
              </div>
              <div style={{ height: "100%" }}>
                <button
                  className="add_flight_btn"
                  style={{ marginBottom: "15px", width: "35%" }}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleCustomField();
                    addCustomField();
                  }}
                >
                  <BsPlusLg /> Add Custom Field
                </button>

                {customFields.map((field, index) => {
                  const isFieldEmpty = field.value.trim() === "";

                  return (
                    <div
                      key={field.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        background: "#F8FAFB",
                        justifyContent: "space-between",
                        paddingLeft: "2%",
                        paddingRight: "2%",
                        borderRadius: "10px",
                        marginBottom: "5%",
                      }}
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          width: "100%",
                          position: "relative",
                        }}
                      >
                        {isCustomFieldEditable ||
                        index === customFields.length - 1 ? (
                          <input
                            style={{
                              height: "100%",
                              border: "none",
                              fontSize: "14px",
                              width: "100%",
                              padding: "4%",
                              maxHeight: "100%",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              background: "transparent",
                              outline: "none",
                            }}
                            type="text"
                            id="CustomFieldname"
                            placeholder="Custom Field"
                            value={field.value}
                            onChange={(e) => {
                              setCustomFields(
                                customFields.map((item, i) =>
                                  i === index
                                    ? { ...item, value: e.target.value }
                                    : item
                                )
                              );
                            }}
                            onBlur={() => {
                              if (isFieldEmpty) {
                                setCustomFields(
                                  customFields.map((item, i) =>
                                    i === index
                                      ? { ...item, value: "Custom Field" }
                                      : item
                                  )
                                );
                                setIsCustomFieldEditable(false);
                              }
                            }}
                          />
                        ) : (
                          <div
                            className="heading4"
                            onClick={() => setIsCustomFieldEditable(true)}
                          >
                            {field.value || "Custom Field"}
                          </div>
                        )}
                      </div>
                      <input
                        style={{ marginRight: "8%", padding: "1.2%" }}
                        type="string"
                        placeholder="Enter the custom value"
                        value={customValue}
                        onChange={(e) => setCustomValue(e.target.value)}
                      />
                      <button
                        onClick={() => removeCustomField(field.id)}
                        style={{
                          border: "none",
                          background: "none",
                          cursor: "pointer",
                        }}
                      >
                        <DeleteOutlineSharpIcon style={{ color: "red" }} />
                      </button>
                    </div>
                  );
                })}
              </div>
              {/* Custom Field end */}
              <button
                className="add_btn"
                style={{ float: "right", marginRight: "10%" }}
              >
                <span>Add Aircraft</span>
              </button>
              <br />
              <br />
              <br />
               
            </div>

          </form>
        </Box>
        </Slide>
      </Modal>
    </div>
  );
}

export default AddAircraftModal;
